import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';

// React rendering of website
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);